import { render, staticRenderFns } from "./EEscolhaDisciplina.vue?vue&type=template&id=db5f20ca"
import script from "./EEscolhaDisciplina.vue?vue&type=script&lang=js"
export * from "./EEscolhaDisciplina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports